import { FeatureFlag } from '@ps/web-core-enums';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { useOnboardingContext } from '@swf/components/Onboarding/OnboardingContext/OnbordingContext';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import { Navigation as BaseNavigation, type NavigationProperties } from '@swf/poker';

import { usePokerSpinAndGoWidget } from '../../model';
import { OnboardingStep } from '../../types';
import type { GameTypeName } from '../../types/Game';

import { WatchGamesButton } from './WatchGames/WatchGamesButton';
import styles from './shared.scss';

const Navigation = ({
  navTabs = [],
  selectedTab,
  onSelectTab
}: NavigationProperties<GameTypeName>) => {
  const { widgetSelect } = usePokerSpinAndGoWidget();
  const watchGamesVisibility = useFeature(FeatureFlag.PKRSpinAndGoWatchGamesVisibility);
  const { setFlowToStep, activeStep, onboardingFinished } = useOnboardingContext();
  const onboardingFocused = OnboardingStep.GameTypeSelection === activeStep;
  const isDesktopEmbedded = useSelector(select.device.isDesktopEmbedded);
  const hasError = useSelector(widgetSelect.hasError);

  return (
    <div
      className={classNames(
        isDesktopEmbedded ? styles.embeddedContainer : styles.navigationContainer,
        styles[`navigationBgr${selectedTab}`]
      )}
    >
      <div className={styles.navigationContent}>
        {watchGamesVisibility && !hasError && <WatchGamesButton />}
        <BaseNavigation
          navTabs={navTabs}
          selectedTab={selectedTab}
          onSelectTab={onSelectTab}
          infoRef={setFlowToStep ? setFlowToStep(OnboardingStep.GameTypeSelection) : null}
          className={classNames(styles.navigation, {
            [styles.onboardingFocus]: !onboardingFinished && onboardingFocused
          })}
        />
      </div>
    </div>
  );
};

export default Navigation;
